export const DOCUMENTS_QUERY_KEY = {
    files: 'pathway-documents',
    filesSection: 'documents-section',
    telemonitoringReports: 'documents-section-telemonitoring-reports',
    appointmentReports: 'documents-section-appointment-reports',
    unopenedTelemonitoringReports: ['telemonitoring-reports', 'list', 'not_opened_by_patient'],
    unopenedAppointmentReports: ['appointment-reports', 'list', 'not_opened_by_patient'],
} as const;

export const DOCUMENTS_UNOPENED_FILTER = {
    telemonitoringReports: { status: 'sent', opened_by_patient: false },
    appointmentReports: { opened_by_patient: false },
} as const;
